export default __webpack_public_path__ + "static/privacy_policy-c2a2651f5506ab4076ae69411b956f07.pdf";